<template>
  <!-- print hidden area -->
  <div
    id="incomestatementPrint"
    style="border:1px solid black;width:100%;"
    v-show="false"
    v-if="isModel"
  >
    <div style="text-align:center;padding-bottom:5px">
      <p style="font-size:15px;margin:0px;font-weight:bold;">{{ shopName }}</p>
    </div>
    <div style="text-align:center">
      <p style="font-size:15px;margin:0px">Statement Of Profit Or Loss</p>
    </div>
    <div style="text-align:center">
      <p style="font-size:15px;margin:0px">
        From [{{ fromMonth }}] To [{{ toMonth }}]
      </p>
    </div>
    <div style="float:right;padding-right:11px">
      <p style="font-size:15px;margin:0px" id="counter"></p>
    </div>
    <br />
    <div style="float:left;padding-left:11px">
      <p style="font-size:15px;margin:0px" id="counter">
        Shop Code: {{ shopCode }}
      </p>
    </div>
    <br />

    <div style="clear:both"></div>
    <div style="height:10px"></div>
    <div style="padding-left:5px;padding-right:5px">
      <table
        style="font-family: arial, sans-serif;border-collapse: collapse;width: 100%;font-size:11px;"
      >
        <thead style="border-bottom:1px solid black;border-top:1px solid black">
          <tr style="line-height: 20px;">
            <th style="border:1px solid black;text-align:center">
              Account Code
            </th>
            <th style="border:1px solid black;text-align:center">
              Account Name
            </th>
            <th style="border:1px solid black;text-align:center">
              Sub Account Budget
            </th>
            <th style="border:1px solid black;text-align:center">Budget</th>
            <th style="border:1px solid black;text-align:center">
              Total Budget
            </th>
            <th
              v-for="(header, index) in dynamicHeaderList"
              :key="'h1' + index"
              style="border:1px solid black;text-align:center"
            >
              {{ header.name }}
            </th>
            <th style="border:1px solid black;text-align:center">
              SubAccount Amount
            </th>
            <th style="border:1px solid black;text-align:center">Amount</th>
            <th style="border:1px solid black;text-align:center">
              Total Amount
            </th>
          </tr>
        </thead>
        <!-- start net sale -->
        <tr style="line-height: 20px;">
          <td
            :colspan="8 + (dynamicHeaderList ? dynamicHeaderList.length : 0)"
            class="font-weight-black"
            style="border:1px solid black;text-align:left;font-weight:bold;"
          >
            REVENUE
          </td>
        </tr>
        <tbody
          v-for="(item, index) in isModel.incomeStatementAccountList.filter(
            (v) =>
              v.sessionName == 'REVENUE' &&
              (balanceType == 'ALL' ? true : v.totalAmount != 0)
          )"
          :key="'R' + index"
        >
          <tr style="line-height: 20px;">
            <td style="border:1px solid black;text-align:left">
              <span>{{ item.parentAccountCode }}</span>
            </td>
            <td style="border:1px solid black;text-align:left">
              <span>{{ item.parentAccountName }}</span>
            </td>
            <td style="border:1px solid black;text-align:center"></td>
            <td style="border:1px solid black;text-align:right">
              <span v-if="item.isSubtract"
                >({{ item.totalBudget | decFormat }})</span
              >
              <span v-else>{{ item.totalBudget | decFormat }}</span>
            </td>
            <td style="border:1px solid black;text-align:center"></td>
            <td
              v-for="(header, index) in dynamicHeaderList"
              :key="'rh1' + index"
              style="border:1px solid black;text-align:right"
            >
              {{
                getShopAmount(header.id, item.totalLedgerByAmountList)
                  | decFormat
              }}
            </td>
            <td style="border:1px solid black;text-align:center"></td>
            <td style="border:1px solid black;text-align:right">
              <span v-if="item.isSubtract"
                >({{ item.totalAmount | decFormat }})</span
              >
              <span v-else>{{ item.totalAmount | decFormat }}</span>
            </td>
            <td style="border:1px solid black;text-align:right"></td>
          </tr>
          <!-- for sub account -->
          <tr
            v-for="(itemdetail, index) in item.incomeStatementDetailList"
            :key="'SR' + index"
            style="line-height: 20px;"
          >
            <td style="border:1px solid black;text-align:left">
              <span>{{ itemdetail.subAccountCode }}</span>
            </td>
            <td style="border:1px solid black;text-align:left">
              <span>{{ itemdetail.subAccountName }}</span>
            </td>
            <td style="border:1px solid black;text-align:right">
              {{ itemdetail.budget | decFormat }}
            </td>
            <td style="border:1px solid black;text-align:right"></td>
            <td style="border:1px solid black;text-align:right"></td>
            <td
              v-for="(header, index) in dynamicHeaderList"
              :key="'SRh1' + index"
              style="border:1px solid black;text-align:right"
            >
              {{
                getShopAmount(header.id, itemdetail.LedgerByAmountList)
                  | decFormat
              }}
            </td>
            <td style="border:1px solid black;text-align:right">
              {{ itemdetail.amount | decFormat }}
            </td>
            <td style="border:1px solid black;text-align:right"></td>
            <td style="border:1px solid black;text-align:right"></td>
          </tr>
          <!-- end sub account -->
        </tbody>
        <tr style="line-height: 20px;">
          <td
            colspan="4"
            style="border:1px solid black;text-align:right;font-weight:bold;"
          >
            Net Sale
          </td>
          <td style="border:1px solid black;text-align:right;font-weight:bold;">
            {{ isModel.totalRevenueBudget | decFormat }}
          </td>
          <td
            v-for="(header, index) in dynamicHeaderList"
            :key="'rsh1' + index"
            style="border:1px solid black;text-align:right;font-weight:bold;"
          >
            {{
              getShopAmount(header.id, isModel.totalRevenueLedgerByAmountList)
                | decFormat
            }}
          </td>
          <td
            style="border:1px solid black;text-align:right;font-weight:bold;"
          ></td>
          <td
            style="border:1px solid black;text-align:right;font-weight:bold;"
          ></td>
          <td style="border:1px solid black;text-align:right;font-weight:bold;">
            {{ isModel.totalRevenue | decFormat }}
          </td>
        </tr>
        <!-- end net sale -->
        <!-- start cost of good sold -->
        <tr style="line-height: 20px;">
          <td
            :colspan="8 + (dynamicHeaderList ? dynamicHeaderList.length : 0)"
            class="font-weight-black"
            style="border:1px solid black;text-align:left;font-weight:bold;"
          >
            COST OF GOOD SOLD
          </td>
        </tr>
        <tbody
          v-for="(item, index) in isModel.incomeStatementAccountList.filter(
            (v) =>
              v.sessionName == 'COST_OF_GOOD_SOLD' &&
              (balanceType == 'ALL' ? true : v.totalAmount != 0)
          )"
          :key="'COGS' + index"
        >
          <tr style="line-height: 20px;">
            <td style="border:1px solid black;text-align:left">
              <span>{{ item.parentAccountCode }}</span>
            </td>
            <td style="border:1px solid black;text-align:left">
              <span>{{ item.parentAccountName }}</span>
            </td>
            <td style="border:1px solid black;text-align:center"></td>
            <td style="border:1px solid black;text-align:right">
              <span v-if="item.isSubtract"
                >({{ item.totalBudget | decFormat }})</span
              >
              <span v-else>{{ item.totalBudget | decFormat }}</span>
            </td>
            <td style="border:1px solid black;text-align:center"></td>
            <td
              v-for="(header, index) in dynamicHeaderList"
              :key="'cogsh1' + index"
              style="border:1px solid black;text-align:right"
            >
              {{
                getShopAmount(header.id, item.totalLedgerByAmountList)
                  | decFormat
              }}
            </td>
            <td style="border:1px solid black;text-align:center"></td>
            <td style="border:1px solid black;text-align:right">
              <span v-if="item.isSubtract"
                >({{ item.totalAmount | decFormat }})</span
              >
              <span v-else>{{ item.totalAmount | decFormat }}</span>
            </td>
            <td style="border:1px solid black;text-align:right"></td>
          </tr>

          <tr
            v-for="(itemdetail, i) in item.incomeStatementDetailList"
            :key="'SCOGS' + i"
            style="line-height: 20px;"
          >
            <td style="border:1px solid black;text-align:left">
              <span>{{ itemdetail.subAccountCode }}</span>
            </td>
            <td style="border:1px solid black;text-align:left">
              <span>{{ itemdetail.subAccountName }}</span>
            </td>
            <td style="border:1px solid black;text-align:right">
              {{ itemdetail.budget | decFormat }}
            </td>
            <td style="border:1px solid black;text-align:right"></td>
            <td style="border:1px solid black;text-align:right"></td>
            <td
              v-for="(header, index) in dynamicHeaderList"
              :key="'SCOGSh1' + index"
              style="border:1px solid black;text-align:right"
            >
              {{
                getShopAmount(header.id, itemdetail.LedgerByAmountList)
                  | decFormat
              }}
            </td>
            <td style="border:1px solid black;text-align:right">
              {{ itemdetail.amount | decFormat }}
            </td>
            <td style="border:1px solid black;text-align:right"></td>
            <td style="border:1px solid black;text-align:right"></td>
          </tr>
        </tbody>
        <tr style="line-height: 20px;">
          <td
            colspan="4"
            style="border:1px solid black;text-align:right;font-weight:bold;"
          >
            Cost Of Sale
          </td>
          <td style="border:1px solid black;text-align:right;font-weight:bold;">
            {{ isModel.totalCostOfGoodSoldBudget | decFormat }}
          </td>
          <td
            v-for="(header, index) in dynamicHeaderList"
            :key="'tcogssh1' + index"
            style="border:1px solid black;text-align:right;font-weight:bold;"
          >
            {{
              getShopAmount(
                header.id,
                isModel.totalCostOfGoodSoldLedgerByAmountList
              ) | decFormat
            }}
          </td>
          <td
            style="border:1px solid black;text-align:right;font-weight:bold;"
          ></td>
          <td
            style="border:1px solid black;text-align:right;font-weight:bold;"
          ></td>
          <td style="border:1px solid black;text-align:right;font-weight:bold;">
            {{ isModel.totalCostOfGoodSold | decFormat }}
          </td>
        </tr>
        <tr style="line-height: 20px;">
          <td
            colspan="4"
            style="border:1px solid black;text-align:right;font-weight:bold;"
          >
            Gross Profit
          </td>
          <td style="border:1px solid black;text-align:right;font-weight:bold;">
            {{ isModel.grossProfitBudget | decFormat }}
          </td>
          <td
            v-for="(header, index) in dynamicHeaderList"
            :key="'gfsh1' + index"
            style="border:1px solid black;text-align:right;font-weight:bold;"
          >
            {{
              getShopAmount(header.id, isModel.grossProfitLedgerByAmountList)
                | decFormat
            }}
          </td>
          <td
            style="border:1px solid black;text-align:right;font-weight:bold;"
          ></td>
          <td
            style="border:1px solid black;text-align:right;font-weight:bold;"
          ></td>
          <td style="border:1px solid black;text-align:right;font-weight:bold;">
            {{ isModel.grossProfit | decFormat }}
          </td>
        </tr>
        <!-- end cost of good sold -->
        <!-- start other income -->
        <tr style="line-height: 20px;">
          <td
            :colspan="8 + (dynamicHeaderList ? dynamicHeaderList.length : 0)"
            class="font-weight-black"
            style="border:1px solid black;text-align:left;font-weight:bold;"
          >
            OTHER INCOME
          </td>
        </tr>
        <tbody
          v-for="(item, index) in isModel.incomeStatementAccountList.filter(
            (v) =>
              v.sessionName == 'OTHER_INCOME' &&
              (balanceType == 'ALL' ? true : v.totalAmount != 0)
          )"
          :key="'OI' + index"
        >
          <tr style="line-height: 20px;">
            <td style="border:1px solid black;text-align:left">
              <span>{{ item.parentAccountCode }}</span>
            </td>
            <td style="border:1px solid black;text-align:left">
              <span>{{ item.parentAccountName }}</span>
            </td>
            <td style="border:1px solid black;text-align:center"></td>
            <td style="border:1px solid black;text-align:right">
              <span v-if="item.isSubtract"
                >({{ item.totalBudget | decFormat }})</span
              >
              <span v-else>{{ item.totalBudget | decFormat }}</span>
            </td>
            <td style="border:1px solid black;text-align:center"></td>
            <td
              v-for="(header, index) in dynamicHeaderList"
              :key="'oih1' + index"
              style="border:1px solid black;text-align:right"
            >
              {{
                getShopAmount(header.id, item.totalLedgerByAmountList)
                  | decFormat
              }}
            </td>
            <td style="border:1px solid black;text-align:center"></td>
            <td style="border:1px solid black;text-align:right">
              <span v-if="item.isSubtract"
                >({{ item.totalAmount | decFormat }})</span
              >
              <span v-else>{{ item.totalAmount | decFormat }}</span>
            </td>
            <td style="border:1px solid black;text-align:right"></td>
          </tr>

          <tr
            v-for="(itemdetail, i) in item.incomeStatementDetailList"
            :key="'SOI' + i"
            style="line-height: 20px;"
          >
            <td style="border:1px solid black;text-align:left">
              <span>{{ itemdetail.subAccountCode }}</span>
            </td>
            <td style="border:1px solid black;text-align:left">
              <span>{{ itemdetail.subAccountName }}</span>
            </td>
            <td style="border:1px solid black;text-align:right">
              {{ itemdetail.budget | decFormat }}
            </td>
            <td style="border:1px solid black;text-align:right"></td>
            <td style="border:1px solid black;text-align:right"></td>
            <td
              v-for="(header, index) in dynamicHeaderList"
              :key="'SOIh1' + index"
              style="border:1px solid black;text-align:right"
            >
              {{
                getShopAmount(header.id, itemdetail.LedgerByAmountList)
                  | decFormat
              }}
            </td>
            <td style="border:1px solid black;text-align:right">
              {{ itemdetail.amount | decFormat }}
            </td>
            <td style="border:1px solid black;text-align:right"></td>
            <td style="border:1px solid black;text-align:right"></td>
          </tr>
        </tbody>
        <tr style="line-height: 20px;">
          <td
            colspan="4"
            style="border:1px solid black;text-align:right;font-weight:bold;"
          >
            Other Income
          </td>
          <td style="border:1px solid black;text-align:right;font-weight:bold;">
            {{ isModel.totalOtherIncomeBudget | decFormat }}
          </td>
          <td
            v-for="(header, index) in dynamicHeaderList"
            :key="'oish1' + index"
            style="border:1px solid black;text-align:right;font-weight:bold;"
          >
            {{
              getShopAmount(
                header.id,
                isModel.totalOtherIncomeLedgerByAmountList
              ) | decFormat
            }}
          </td>
          <td
            style="border:1px solid black;text-align:right;font-weight:bold;"
          ></td>
          <td
            style="border:1px solid black;text-align:right;font-weight:bold;"
          ></td>
          <td style="border:1px solid black;text-align:right;font-weight:bold;">
            {{ isModel.totalOtherIncome | decFormat }}
          </td>
        </tr>
        <tr style="line-height: 20px;">
          <td
            colspan="4"
            style="border:1px solid black;text-align:right;font-weight:bold;"
          >
            Total Income
          </td>
          <td style="border:1px solid black;text-align:right;font-weight:bold;">
            {{
              (isModel.grossProfitBudget + isModel.totalOtherIncomeBudget)
                | decFormat
            }}
          </td>
          <td
            v-for="(header, index) in dynamicHeaderList"
            :key="'ticsh1' + index"
            style="border:1px solid black;text-align:right;font-weight:bold;"
          >
            {{
              getShopAmount(header.id, isModel.totalIncomeLedgerByAmountList)
                | decFormat
            }}
          </td>
          <td
            style="border:1px solid black;text-align:right;font-weight:bold;"
          ></td>
          <td
            style="border:1px solid black;text-align:right;font-weight:bold;"
          ></td>
          <td style="border:1px solid black;text-align:right;font-weight:bold;">
            {{ (isModel.grossProfit + isModel.totalOtherIncome) | decFormat }}
          </td>
        </tr>
        <!-- end other income -->
        <!-- start administration expense -->
        <tr style="line-height: 20px;">
          <td
            :colspan="8 + (dynamicHeaderList ? dynamicHeaderList.length : 0)"
            class="font-weight-black"
            style="border:1px solid black;text-align:left;font-weight:bold;"
          >
            ADMINISTRATION EXPENSES
          </td>
        </tr>
        <tbody
          v-for="(item, index) in isModel.incomeStatementAccountList.filter(
            (v) =>
              v.sessionName == 'ADMINISTRATION_EXPENSES' &&
              (balanceType == 'ALL' ? true : v.totalAmount != 0)
          )"
          :key="'AE' + index"
        >
          <tr style="line-height: 20px;">
            <td style="border:1px solid black;text-align:left">
              <span>{{ item.parentAccountCode }}</span>
            </td>
            <td style="border:1px solid black;text-align:left">
              <span>{{ item.parentAccountName }}</span>
            </td>
            <td style="border:1px solid black;text-align:center"></td>
            <td style="border:1px solid black;text-align:right">
              <span v-if="item.isSubtract"
                >({{ item.totalBudget | decFormat }})</span
              >
              <span v-else>{{ item.totalBudget | decFormat }}</span>
            </td>
            <td style="border:1px solid black;text-align:center"></td>
            <td
              v-for="(header, index) in dynamicHeaderList"
              :key="'aeh1' + index"
              style="border:1px solid black;text-align:right"
            >
              {{
                getShopAmount(header.id, item.totalLedgerByAmountList)
                  | decFormat
              }}
            </td>
            <td style="border:1px solid black;text-align:center"></td>
            <td style="border:1px solid black;text-align:right">
              <span v-if="item.isSubtract"
                >({{ item.totalAmount | decFormat }})</span
              >
              <span v-else>{{ item.totalAmount | decFormat }}</span>
            </td>
            <td style="border:1px solid black;text-align:right"></td>
          </tr>

          <tr
            v-for="(itemdetail, i) in item.incomeStatementDetailList"
            :key="'SAE' + i"
            style="line-height: 20px;"
          >
            <td style="border:1px solid black;text-align:left">
              <span>{{ itemdetail.subAccountCode }}</span>
            </td>
            <td style="border:1px solid black;text-align:left">
              <span>{{ itemdetail.subAccountName }}</span>
            </td>
            <td style="border:1px solid black;text-align:right">
              {{ itemdetail.budget | decFormat }}
            </td>
            <td style="border:1px solid black;text-align:right"></td>
            <td style="border:1px solid black;text-align:right"></td>
            <td
              v-for="(header, index) in dynamicHeaderList"
              :key="'SAEh1' + index"
              style="border:1px solid black;text-align:right"
            >
              {{
                getShopAmount(header.id, itemdetail.LedgerByAmountList)
                  | decFormat
              }}
            </td>
            <td style="border:1px solid black;text-align:right">
              {{ itemdetail.amount | decFormat }}
            </td>
            <td style="border:1px solid black;text-align:right"></td>
            <td style="border:1px solid black;text-align:right"></td>
          </tr>
        </tbody>
        <tr style="line-height: 20px;">
          <td
            colspan="4"
            style="border:1px solid black;text-align:right;font-weight:bold;"
          >
            Total Administration Expense
          </td>
          <td style="border:1px solid black;text-align:right;font-weight:bold;">
            {{ isModel.totalAdministrationExpenseBudget | decFormat }}
          </td>
          <td
            v-for="(header, index) in dynamicHeaderList"
            :key="'taesh1' + index"
            style="border:1px solid black;text-align:right;font-weight:bold;"
          >
            {{
              getShopAmount(
                header.id,
                isModel.totalAdministrationExpenseLedgerByAmountList
              ) | decFormat
            }}
          </td>
          <td
            style="border:1px solid black;text-align:right;font-weight:bold;"
          ></td>
          <td
            style="border:1px solid black;text-align:right;font-weight:bold;"
          ></td>
          <td style="border:1px solid black;text-align:right;font-weight:bold;">
            {{ isModel.totalAdministrationExpense | decFormat }}
          </td>
        </tr>
        <!-- end administration expnese -->
        <!-- start selling and distribution expense -->
        <tr style="line-height: 20px;">
          <td
            :colspan="8 + (dynamicHeaderList ? dynamicHeaderList.length : 0)"
            class="font-weight-black"
            style="border:1px solid black;text-align:left;font-weight:bold;"
          >
            SELLING & DISTRIBUTION EXPENSES
          </td>
        </tr>
        <tbody
          v-for="(item, index) in isModel.incomeStatementAccountList.filter(
            (v) =>
              v.sessionName == 'SELLING_DISTRIBUTION_EXPENSES' &&
              (balanceType == 'ALL' ? true : v.totalAmount != 0)
          )"
          :key="'SDE' + index"
        >
          <tr style="line-height: 20px;">
            <td style="border:1px solid black;text-align:left">
              <span>{{ item.parentAccountCode }}</span>
            </td>
            <td style="border:1px solid black;text-align:left">
              <span>{{ item.parentAccountName }}</span>
            </td>
            <td style="border:1px solid black;text-align:center"></td>
            <td style="border:1px solid black;text-align:right">
              <span v-if="item.isSubtract"
                >({{ item.totalBudget | decFormat }})</span
              >
              <span v-else>{{ item.totalBudget | decFormat }}</span>
            </td>
            <td style="border:1px solid black;text-align:center"></td>
            <td
              v-for="(header, index) in dynamicHeaderList"
              :key="'sdeh1' + index"
              style="border:1px solid black;text-align:right"
            >
              {{
                getShopAmount(header.id, item.totalLedgerByAmountList)
                  | decFormat
              }}
            </td>
            <td style="border:1px solid black;text-align:center"></td>
            <td style="border:1px solid black;text-align:right">
              <span v-if="item.isSubtract"
                >({{ item.totalAmount | decFormat }})</span
              >
              <span v-else>{{ item.totalAmount | decFormat }}</span>
            </td>
            <td style="border:1px solid black;text-align:right"></td>
          </tr>

          <tr
            v-for="(itemdetail, i) in item.incomeStatementDetailList"
            :key="'SSDE' + i"
            style="line-height: 20px;"
          >
            <td style="border:1px solid black;text-align:left">
              <span>{{ itemdetail.subAccountCode }}</span>
            </td>
            <td style="border:1px solid black;text-align:left">
              <span>{{ itemdetail.subAccountName }}</span>
            </td>
            <td style="border:1px solid black;text-align:right">
              {{ itemdetail.budget | decFormat }}
            </td>
            <td style="border:1px solid black;text-align:right"></td>
            <td style="border:1px solid black;text-align:right"></td>
            <td
              v-for="(header, index) in dynamicHeaderList"
              :key="'SSDEh1' + index"
              style="border:1px solid black;text-align:right"
            >
              {{
                getShopAmount(header.id, itemdetail.LedgerByAmountList)
                  | decFormat
              }}
            </td>
            <td style="border:1px solid black;text-align:right">
              {{ itemdetail.amount | decFormat }}
            </td>
            <td style="border:1px solid black;text-align:right"></td>
            <td style="border:1px solid black;text-align:right"></td>
          </tr>
        </tbody>
        <tr style="line-height: 20px;">
          <td
            colspan="4"
            style="border:1px solid black;text-align:right;font-weight:bold;"
          >
            Total Selling & Distribution Expenses
          </td>
          <td style="border:1px solid black;text-align:right;font-weight:bold;">
            {{ isModel.totalSellingAndDistributionExpenseBudget | decFormat }}
          </td>
          <td
            v-for="(header, index) in dynamicHeaderList"
            :key="'tsadesh1' + index"
            style="border:1px solid black;text-align:right;font-weight:bold;"
          >
            {{
              getShopAmount(
                header.id,
                isModel.totalSellingAndDistributionLedgerByAmountList
              ) | decFormat
            }}
          </td>
          <td
            style="border:1px solid black;text-align:right;font-weight:bold;"
          ></td>
          <td
            style="border:1px solid black;text-align:right;font-weight:bold;"
          ></td>
          <td style="border:1px solid black;text-align:right;font-weight:bold;">
            {{ isModel.totalSellingAndDistributionExpense | decFormat }}
          </td>
        </tr>
        <!-- end selling and distribution expense -->

        <!-- start Other expense -->
        <tr style="line-height: 20px;">
          <td
            :colspan="8 + (dynamicHeaderList ? dynamicHeaderList.length : 0)"
            class="font-weight-black"
            style="border:1px solid black;text-align:left;font-weight:bold;"
          >
            OTHER EXPENSES
          </td>
        </tr>
        <tbody
          v-for="(item, index) in isModel.incomeStatementAccountList.filter(
            (v) =>
              v.sessionName == 'OTHER_EXPENSES' &&
              (balanceType == 'ALL' ? true : v.totalAmount != 0)
          )"
          :key="'OE' + index"
        >
          <tr style="line-height: 20px;">
            <td style="border:1px solid black;text-align:left">
              <span>{{ item.parentAccountCode }}</span>
            </td>
            <td style="border:1px solid black;text-align:left">
              <span>{{ item.parentAccountName }}</span>
            </td>
            <td style="border:1px solid black;text-align:center"></td>
            <td style="border:1px solid black;text-align:right">
              <span v-if="item.isSubtract"
                >({{ item.totalBudget | decFormat }})</span
              >
              <span v-else>{{ item.totalBudget | decFormat }}</span>
            </td>
            <td style="border:1px solid black;text-align:center"></td>
            <td
              v-for="(header, index) in dynamicHeaderList"
              :key="'oeh1' + index"
              style="border:1px solid black;text-align:right"
            >
              {{
                getShopAmount(header.id, item.totalLedgerByAmountList)
                  | decFormat
              }}
            </td>
            <td style="border:1px solid black;text-align:center"></td>
            <td style="border:1px solid black;text-align:right">
              <span v-if="item.isSubtract"
                >({{ item.totalAmount | decFormat }})</span
              >
              <span v-else>{{ item.totalAmount | decFormat }}</span>
            </td>
            <td style="border:1px solid black;text-align:right"></td>
          </tr>

          <tr
            v-for="(itemdetail, i) in item.incomeStatementDetailList"
            :key="'SOE' + i"
            style="line-height: 20px;"
          >
            <td style="border:1px solid black;text-align:left">
              <span>{{ itemdetail.subAccountCode }}</span>
            </td>
            <td style="border:1px solid black;text-align:left">
              <span>{{ itemdetail.subAccountName }}</span>
            </td>
            <td style="border:1px solid black;text-align:right">
              {{ itemdetail.budget | decFormat }}
            </td>
            <td style="border:1px solid black;text-align:right"></td>
            <td style="border:1px solid black;text-align:right"></td>
            <td
              v-for="(header, index) in dynamicHeaderList"
              :key="'SOEh1' + index"
              style="border:1px solid black;text-align:right"
            >
              {{
                getShopAmount(header.id, itemdetail.LedgerByAmountList)
                  | decFormat
              }}
            </td>
            <td style="border:1px solid black;text-align:right">
              {{ itemdetail.amount | decFormat }}
            </td>
            <td style="border:1px solid black;text-align:right"></td>
            <td style="border:1px solid black;text-align:right"></td>
          </tr>
        </tbody>
        <tr style="line-height: 20px;">
          <td
            colspan="4"
            style="border:1px solid black;text-align:right;font-weight:bold;"
          >
            Total Other Expenses
          </td>
          <td style="border:1px solid black;text-align:right;font-weight:bold;">
            {{ isModel.totalOtherExpensesBudget | decFormat }}
          </td>
          <td
            v-for="(header, index) in dynamicHeaderList"
            :key="'toesh1' + index"
            style="border:1px solid black;text-align:right;font-weight:bold;"
          >
            {{
              getShopAmount(
                header.id,
                isModel.totalOtherExpensesLedgerByAmountList
              ) | decFormat
            }}
          </td>
          <td
            style="border:1px solid black;text-align:right;font-weight:bold;"
          ></td>
          <td
            style="border:1px solid black;text-align:right;font-weight:bold;"
          ></td>
          <td style="border:1px solid black;text-align:right;font-weight:bold;">
            {{ isModel.totalOtherExpenses | decFormat }}
          </td>
        </tr>
        <!-- end Other expense -->
        <tr style="line-height: 20px;">
          <td
            colspan="4"
            style="border:1px solid black;text-align:right;font-weight:bold;"
          >
            Total Expense
          </td>
          <td style="border:1px solid black;text-align:right;font-weight:bold;">
            {{
              (isModel.totalAdministrationExpenseBudget +
                isModel.totalSellingAndDistributionExpenseBudget +
                isModel.totalOtherExpensesBudget)
                | decFormat
            }}
          </td>
          <td
            v-for="(header, index) in dynamicHeaderList"
            :key="'teh1' + index"
            style="border:1px solid black;text-align:right;font-weight:bold;"
          >
            {{
              getShopAmount(header.id, isModel.totalExpenseLedgerByAmountList)
                | decFormat
            }}
          </td>
          <td
            style="border:1px solid black;text-align:right;font-weight:bold;"
          ></td>
          <td
            style="border:1px solid black;text-align:right;font-weight:bold;"
          ></td>
          <td style="border:1px solid black;text-align:right;font-weight:bold;">
            {{
              (isModel.totalAdministrationExpense +
                isModel.totalSellingAndDistributionExpense +
                isModel.totalOtherIncome)
                | decFormat
            }}
          </td>
        </tr>
        <tr style="line-height: 20px;">
          <td
            colspan="4"
            style="border:1px solid black;text-align:right;font-weight:bold;"
          >
            Net Profit or loss
          </td>
          <td style="border:1px solid black;text-align:right;font-weight:bold;">
            {{ isModel.profitLossAmountBudget | decFormat }}
          </td>
          <td
            v-for="(header, index) in dynamicHeaderList"
            :key="'npolh1' + index"
            style="border:1px solid black;text-align:right;font-weight:bold;"
          >
            {{
              getShopAmount(header.id, isModel.netProfitLossLedgerByAmountList)
                | decFormat
            }}
          </td>
          <td
            style="border:1px solid black;text-align:right;font-weight:bold;"
          ></td>
          <td
            style="border:1px solid black;text-align:right;font-weight:bold;"
          ></td>
          <td style="border:1px solid black;text-align:right;font-weight:bold;">
            {{ isModel.profitLossAmount | decFormat }}
          </td>
        </tr>
      </table>

      <div style="height:10px"></div>
    </div>
  </div>
</template>
<script>
export default {
  props: [
    "isModel",
    "shopName",
    "shopCode",
    "fromMonth",
    "toMonth",
    "balanceType",
    "dynamicHeaderList",
  ],
  methods: {
    getShopAmount(id, item) {
      let amount = 0;
      console.log("amount>..", amount);
      console.log("itemlist>..", item);
      if (item) {
        let element = item.find((p) => p.ledgerById === id);
        if (element) {
          amount = element.ledgerByAmount;
        }
      }
      return amount;
    },
  },
};
</script>
